module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-banner"
  }, [_c('div', {
    staticClass: "lo-container"
  }, [_c('div', {
    staticClass: "lo-12-xs lo-4-sm -gap-32px"
  }, [_c('div', {
    staticClass: "_dp-f _fdrt-r _fdrt-cl-sm _alit-ct-sm _jtfct-fst-sm _pst-rlt _mgbt-32px _mgbt-0px-sm"
  }, [_c('img', {
    staticClass: "_w-128px _h-128px _w-256px-sm _mxw-100pct-sm _h-256px-sm _mgr-0px-sm _pst-asl _pst-rlt-sm _opct-20 _opct-100-sm _l-0px _r-0px _mgh-at _mgh-0px-sm",
    attrs: {
      "src": require("@/assets/home/atomic.svg"),
      "alt": "atomic"
    }
  }), _vm._v(" "), _c('div', [_c('h4', {
    staticClass: "_tal-ct-sm _mgbt-8px"
  }, [_vm._v("ATOMIC")]), _vm._v(" "), _c('p', {
    staticClass: "_tal-l _fs-5 _lh-150pct"
  }, [_vm._v("\n            Atomic Class ที่ยืดหยุ่น และคลอบคลุมการใช้งานตามที่คุณต้องการ\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _fdrt-r _fdrt-cl-sm _alit-ct-sm _pst-rlt _mgbt-32px _mgbt-0px-sm"
  }, [_c('img', {
    staticClass: "_w-128px _h-128px _w-256px-sm _mxw-100pct-sm _h-256px-sm _mgr-0px-sm _pst-asl _pst-rlt-sm _opct-20 _opct-100-sm _l-0px _r-0px _mgh-at _mgh-0px-sm",
    attrs: {
      "src": require("@/assets/home/components.svg"),
      "alt": "component"
    }
  }), _vm._v(" "), _c('div', [_c('h4', {
    staticClass: "_tal-ct-sm _mgbt-8px"
  }, [_vm._v("COMPONENTS")]), _vm._v(" "), _c('p', {
    staticClass: "_tal-l _fs-5 _lh-150pct"
  }, [_vm._v("\n            มี Components และ Utility พื้นฐานเพื่อให้คุณเริ่มทำงานง่ายขึ้น\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _fdrt-r _fdrt-cl-sm _alit-ct-sm _pst-rlt _mgbt-32px _mgbt-0px-sm"
  }, [_c('img', {
    staticClass: "_w-128px _h-128px _w-256px-sm _mxw-100pct-sm _h-256px-sm _mgr-0px-sm _pst-asl _pst-rlt-sm _opct-20 _opct-100-sm _l-0px _r-0px _mgh-at _mgh-0px-sm",
    attrs: {
      "src": require("@/assets/home/responsive.svg"),
      "alt": "responsive"
    }
  }), _vm._v(" "), _c('div', [_c('h4', {
    staticClass: "_tal-ct-sm _mgbt-8px"
  }, [_vm._v("RESPONSIVE")]), _vm._v(" "), _c('p', {
    staticClass: "_tal-l _fs-5 _lh-150pct"
  }, [_vm._v("\n            ระบบ Responsive ที่สะดวก และใช้งานง่าย\n          ")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dad0aa10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/home/HomeBenefits.vue
// module id = 145
// module chunks = 0